export * from "@/ui/components/typography/TextTitle/TextTitle";
export * from "@/ui/components/typography/TextTitle/TextTitle.config";
